<template>
    <div>
        <form class="form-horizontal"
            enctype="multipart/form-data"
            @submit.prevent="store"
            @keydown="form.errors.clear($event.target.name)"
            autocomplete="off"
        >
            <div v-if="this.type == 'select' || this.type == 'multi_select'" class="form-group" v-bind:class="{ 'has-danger' : form.errors.has(this.setting.name) }">
                <label v-if="setting != null" class="form-control-label" :for="name">{{ uLang('app.' + this.setting.name) }}</label>
                <multiselect
                    v-model="form['value']"
                    :options="options"
                    label="name"
                    track-by="name"
                    :multiple="multiple"
                    :close-on-select="false"
                    :selectedLabel="uLang('app.select')"
                    :selectLabel="uLang('app.press_enter_to_select')"
                    :deselectLabel="uLang('app.press_enter_to_remove')"
                    :placeholder="uLang('app.select_option')"
                >
                    <p slot="noResult">{{ uLang('app.no_results_found_change_query') }}</p>
                </multiselect>
                <span class="help-block form-control-feedback" v-if="form.errors.has(this.setting.name)" v-text="form.errors.get(this.setting.name)"></span>
            </div>
            <div class="form-group">
                <input :disabled="form.busy" type="button" :value="uLang('app.save_setting')" @click="store()" class="btn btn-brand" />
            </div>
        </form>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import Multiselect from 'vue-multiselect'
    import FormAdminSetting from '~/components/forms/admin/relation/form'
    import { DestroyAlert } from '~/Swals'

    export default {
        name: 'form-setting-countries',
        props: {
            settingId: {
                required: true,
            },
        },
        components: {
            Multiselect
        },
        data() {
            return {
                form: new Form({
                    value: {},
                    setting_id: ''
                }),
                name: '',
                type: '',
                setting: '',
                options: [],
                multiple: false
            }
        },
        mounted: function () {
            this.retrieveValues();
        },
        methods: {
            async store() {
                await this.form['patch']('/api/admin/settings/' + this.setting.id);
            },

            async retrieveValues() {
                const { data } = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

                this.form.setting_id = data.setting.id;
                this.form.value = data.values;
                this.type = data.setting.input_type;
                this.setting = data.setting;
                this.getCountries(data.values);
            },

            async getCountries(selected) {
                const { data } = await window.axios.get('/api/countries');

                this.options = data;
                this.multiple = true;
                this.form.fill(selected);
            },

            async retrieveSetting() {
                const { data } = await window.axios.get('/api/admin/settings/' + this.id);
                this.name = data.name;
            }
        }
    }
</script>

<style lang="css" scoped>

</style>